import {DataStatus} from 'platform/components';
import {Show} from 'platform/foundation';

import {head, isNil, isNotNil} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';

import {useRequiredParams} from 'shared/web';

import {InspectionDetail} from './components/InspectionDetail';

export function ReturnInspections() {
  const {id: rentalOrderId} = useRequiredParams();
  const {data: rentalOrder, isLoading: isLoadingRentalOrder} = useGetRentalOrderQuery({
    rentalOrderId,
  });

  const returnInspectionId = head(rentalOrder?.returnVehicleInspections ?? []);
  const vehicleId = rentalOrder?.rentalVehicleId;

  return (
    <DataStatus
      isLoading={isLoadingRentalOrder}
      isEmpty={isNil(returnInspectionId)}
      emptyMessage={i18n.t('page.rentalOrder.labels.noReturnInspection')}
      minHeight={75}
    >
      <Show
        when={
          isNotNil(returnInspectionId) && isNotNil(vehicleId)
            ? {returnInspectionId, vehicleId}
            : null
        }
      >
        {(inspection) => (
          <InspectionDetail
            isRent={false}
            vehicleId={inspection.vehicleId}
            inspectionId={inspection.returnInspectionId}
          />
        )}
      </Show>
    </DataStatus>
  );
}
